import { render, staticRenderFns } from "./BaseButtonSaveSearch.vue?vue&type=template&id=6a63dac5"
import script from "./BaseButtonSaveSearch.vue?vue&type=script&lang=js"
export * from "./BaseButtonSaveSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports